import {
  AnomalyApi,
  AnomalyHistoryQueryParams,
} from '@api/twin/AnomalyApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import {
  keepPreviousData,
  useInfiniteQuery,
} from '@tanstack/react-query';
import { anomalyQueryKeys } from '../query-keys';

export const useGetAnomalyHistory = (
  projectId: number,
  anomalyId: number,
  anomalyHistoryQueryParams: AnomalyHistoryQueryParams = {
    pageNumber: 1,
    pageSize: 10,
    orderBy: 'creationDate',
    orderDirection: 'desc',
  }) => {
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;

  return useInfiniteQuery({
    queryKey: anomalyQueryKeys.history(anomalyId, anomalyHistoryQueryParams),
    queryFn: ({ pageParam }) => {
      return AnomalyApi(client).getAnomalyHistory(projectId, anomalyId, {
        ...anomalyHistoryQueryParams,
        pageNumber: pageParam,
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.totalPages > lastPage.pageNumber) {
        return lastPage.pageNumber + 1;
      }

      return undefined;
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};
